import * as React from 'react';
import * as S from './styles';
import { IPlataformProps } from './types';
import { getRatingRecommended } from '../../utils'
import LinkIcon from "common/icons/linkIcon";

const Platform: React.FC<IPlataformProps> = ({provider, starColor, linkColor, bodyColor}) => {
    return (
        <S.Root>
            <S.InfoContainer>
                <S.Texto style={{color: bodyColor}} >{provider.provider}</S.Texto>
                {provider.totalReviews>0 ?
                <S.Texto style={{display: 'flex', color: bodyColor}} >{`${provider.totalReviews?.toLocaleString('en-US')} Reviews`}
                {provider.listingURL && provider.listingURL!=='' &&
                <S.Image onClick={() => { window.open(provider.listingURL, "_blank");}}>
                <LinkIcon fillColor={linkColor}/>
                </S.Image>
                }
                </S.Texto>
                : <S.NoReviewsText>
                    No reviews yet
                </S.NoReviewsText>}
            </S.InfoContainer>
            <S.StarsContainer>
                {getRatingRecommended({
                    provider: provider.provider,
                    recommended: provider.totalRecommended>provider.totalNotRecommended,
                    rating: provider.averageStartRating,
                    starStyle: {width:'30.3px', height: '33.2px'},
                    thumbsStyle: {width: "auto", height: "30"},
                    showEmptyStars: true,
                    totalRecommended: provider.totalRecommended,
                    totalNotRecommended: provider.totalNotRecommended,
                    thumbtext: true, 
                    starColor: starColor
                } )}
            </S.StarsContainer>
        </S.Root>
    )
}

export default Platform;
